/**
 * @module Test
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */

import { Pipe, PipeTransform } from '@angular/core';

const PADDING = '000000';

@Pipe({ name: 'dollarAmount' })
export class DollarPipe implements PipeTransform {
  private PREFIX: string;
  private DECIMAL_SEPARATOR: string;
  private SUFFIX: string;
  private base: number = 10;
  private indexOne: number = 1;
  private indexZero: number = 0;

  constructor() {
    // TODO comes from configuration settings
    this.PREFIX = '';
    this.DECIMAL_SEPARATOR = '.';
    this.SUFFIX = ' $';
  }

  public transform(value: string, fractionSize: number = 2): string {
    const parsedValue = value !== null && value !== undefined ? value : '';
    const subStr: string[] = parsedValue.toString().split('.');
    let fraction: string = '';
    const integer: string = subStr[this.indexZero];
    if (subStr[this.indexOne]) {
      fraction = subStr[this.indexOne];
    }
    fraction =
      fractionSize > 0
        ? this.DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, fractionSize)
        : '';
    return this.PREFIX + this.SUFFIX + integer + fraction;
  }

  public parse(value: string, fractionSize: number = 2): string {
    let fraction: string = '';
    const subStr: string[] = (value || '')
      .replace(this.PREFIX, '')
      .replace(this.SUFFIX, '')
      .split(this.DECIMAL_SEPARATOR);
    const integer: string = subStr[this.indexZero];
    if (subStr[this.indexOne]) {
      fraction = subStr[this.indexOne];
    }
    fraction =
      parseInt(fraction, this.base) > 0 && fractionSize > 0
        ? this.DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, fractionSize)
        : '';

    return integer + fraction;
  }
}
